export default __webpack_public_path__ + "static/media/pursuit-menu-echelon-off.58b59dce.svg";